// Validation du « Numéro de dossier de cour » (daj.adda544) — réplication fidèle
// du Legacy (CodeDaj.ValidMaskDossierCour, CodeComparution.ValidNoCause /
// ValidNoDossCours). Format : GGG-JJ-NNNNNN-C (14 chiffres) =
//   greffe(3) + juridiction(2) + séquence(6) + chiffre de contrôle(1, Luhn mod-10).

// Greffes valides (gTablGref)
const GREF = new Set([
  "100","105","110","115","120","125","130","135","140","145","150","151","152",
  "153","154","155","156","157","160","161","162","165","166","170","175","176",
  "200","201","205","206","210","215","216","217","218","220","225","230","231",
  "235","240","250","255","260","300","305","310","350","355","356","360","400",
  "401","405","406","410","415","416","417","420","421","425","430","435","450",
  "451","452","455","460","461","465","466","470","475","480","485","486","487",
  "490","500","501","504","505","506","507","508","509","510","511","512","513",
  "515","516","517","518","519","520","521","525","526","527","528","529","530",
  "531","532","533","534","535","536","537","538","539","540","541","550","551",
  "552","553","555","560","565","570","600","605","610","614","615","620","625",
  "630","635","640","650","652","655","660","665","700","705","710","715","716",
  "720","721","722","723","724","725","726","730","731","732","750","751","752",
  "755","756","757","758","760","765","766","769","770","771","772","773","774",
  "775","776","777","778","779","910",
]);

// Juridictions valides (gTablJurid), codes 2 chiffres (zéro-padding Legacy)
const JURID = new Set([
  "00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15",
  "16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31",
  "32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47",
  "48","49","50","51","52","53","54","55","59","61","62","63","64","66","67","72",
  "73","80","83","90","92","99",
]);

// Masque progressif de saisie : insère les tirets au fur et à mesure (GGG-JJ-NNNNNN-C)
export function maskCourNo(raw) {
  const d = String(raw == null ? "" : raw).replace(/\D/g, "").slice(0, 14);
  let out = d.slice(0, 3);
  if (d.length > 3) out += "-" + d.slice(3, 5);
  if (d.length > 5) out += "-" + d.slice(5, 11);
  if (d.length > 11) out += "-" + d.slice(11, 14);
  return out;
}

export function cleanCourNo(v) {
  return String(v == null ? "" : v).replace(/[-_\s]/g, "");
}

// Formate 14 chiffres en GGG-JJ-NNNNNN-C
export function formatCourNo(v) {
  const c = cleanCourNo(v);
  if (c.length !== 14) return String(v == null ? "" : v);
  return `${c.slice(0, 3)}-${c.slice(3, 5)}-${c.slice(5, 11)}-${c.slice(11, 14)}`;
}

// Retourne { ok, reason } — reason ∈ 'empty'|'mask'|'cause'|'check'|null
export function validateCourNo(v) {
  const c = cleanCourNo(v);
  if (c === "") return { ok: true, reason: "empty" };
  if (c.length !== 14 || !/^\d{14}$/.test(c)) return { ok: false, reason: "mask" };
  const gref = c.slice(0, 3);
  const jurid = c.slice(3, 5);
  if (!GREF.has(gref) || !JURID.has(jurid)) return { ok: false, reason: "cause" };
  // Chiffre de contrôle (Luhn mod-10) sur les 13 premiers chiffres
  let tot = 0;
  for (let i = 1; i <= 13; i++) {
    let d = parseInt(c.charAt(i - 1), 10);
    if (i % 2 !== 0) {           // positions impaires (1-based) : doublées
      d = d * 2;
      if (d > 9) d = Math.floor(d / 10) + (d % 10);
    }
    tot += d;                    // positions paires : telles quelles
  }
  const check = (10 - (tot % 10)) % 10;
  if (check !== parseInt(c.charAt(13), 10)) return { ok: false, reason: "check" };
  return { ok: true, reason: null };
}

export function courNoMessage(reason) {
  switch (reason) {
    case "mask":
      return "Le numéro de dossier de cour doit être composé de 14 chiffres.";
    case "cause":
      return "Le numéro de cause est invalide. Veuillez vérifier...";
    case "check":
      return "Numéro de dossier de cour invalide. Veuillez vérifier...";
    default:
      return "";
  }
}
